// import DefaultLegacyImport from '@elliemae/ds-legacy-uploader';
// export {
//   DSUploader,
//   UploaderWithSchema,
//   DSUploaderName,
//   DSUploaderSlots,
//   defaultActions,
//   DSUploaderDataTestIds,
// } from '@elliemae/ds-legacy-uploader';
// export default DefaultLegacyImport;

export * from '@elliemae/ds-legacy-uploader';
